export default "__VITE_ASSET__ff683829__"